export {
  PLUGIN_KEY,
  PLUGIN_PRIORITY,
  ManualColumnFreeze,
} from './manualColumnFreeze';
